import { Banner, BannerTitle } from "@aircall/ds";
import { Info } from "@aircall/react-icons";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

/**
 * `RequireAgentLicense` is a route guard: when no call participant holds an AI
 * license it renders the info banner below, otherwise it renders the routed
 * `<Outlet />`. Only the banner branch has a visual output, so that is what is
 * showcased here (the guard itself needs the call store, Apollo and the router).
 */
function NoLicenseState() {
  return (
    <div className="p-4">
      <Banner variant="info">
        <Info />
        <BannerTitle>
          None of the participants has an AI license enabled.
        </BannerTitle>
      </Banner>
    </div>
  );
}

export function PlaygroundRequireAgentLicense() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          No AI license (banner branch)
        </PlaygroundSubSectionTitle>
        <NoLicenseState />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
